import React from 'react';

const LoadingScreen: React.FC = () => {
    return (
        <div className="min-h-screen bg-gradient-legal flex items-center justify-center">
            <div className="card-glass p-8 text-center animate-scale-in">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-gold rounded-2xl mb-4 shadow-gold">
                    <div className="spinner-legal border-white"></div>
                </div>
                <h2 className="text-xl font-semibold text-navy mb-2">Cargando Legal Pro</h2>
                <p className="text-slate-600">Inicializando aplicación...</p>
            </div>
        </div>
    );
};

export default LoadingScreen;